

















































import Vue from 'vue'
import {Prop,Component,Mixins} from 'vue-property-decorator';
import TablaGeneral from '@/components/General/TablaGeneral.vue';
import Formulario from '@/components/General/Formulario.vue';
import UnidadMedida from '@/entidades/Plantacion/UnidadMedida';
import ModeloGenerico from '@/Generico/ModeloGenerico';
import ResponseGenerico from '@/entidades/ResponseGenerico';
import MensajeConfirmacion from '@/components/General/Confirmacion.vue';
import {Mutation} from 'vuex-class'
import Loading from '@/entidades/Sistema/Loading'
import Alerta from '@/entidades/Sistema/Alerta'


@Component({
    name : 'UnidadMedida',
    components:{
        TablaGeneral,
        Formulario,
        MensajeConfirmacion
    }
})
export default class UnidadMedidaView extends Vue
{
    @Mutation('mostrarLoading',{namespace:'sistemaModule'}) mostrarLoading!:Function;
	@Mutation('mostarAlert',{namespace:'sistemaModule'}) mostarAlert!:Function;

    header:{text:string,sortable:boolean,value:string}[] =[
            {text:"Descripcion",sortable:true,value:'descripcion'},
            {text:"Editar",sortable:true,value:'actions'},
            {text:"Estado",sortable:true,value:'estado'},
    ]
   listadoUnidadMedida:Array<UnidadMedida> = [];
   search:string="";

   modalAgregarUnidadMedida:boolean =false;
   titulo:string = "";
   action:number = 1;
   modalAgregarUnidadMedidaName:string = "";
   modeloGenerico:ModeloGenerico |undefined = new ModeloGenerico();
   componenteVersatil:string="";
   valorConfirmacion:boolean = false;
   unidadEdicion:UnidadMedida |undefined = undefined;
   mensaje:string="";
   async ObtenerUnidadMedida()
   {
       try
       {
           this.mostrarLoading(new Loading(true,"Obteniendo Registros"));
           let response = await UnidadMedida.Obtener();
           if(response.isSuccess == true)
           {
               this.listadoUnidadMedida = response.isResult;
           }
           else
           {
               this.mostarAlert(new Alerta(response.isMessage,true,"danger",2000));
           }
       }
       catch(error)
       {
              //@ts-ignore
           this.mostarAlert(new Alerta(error,true,"danger",2000));
       }finally{
            this.mostrarLoading(new Loading(false,""));
        }
   }

   async guardarDb(id:number,descripcion:string)
   {
       try
       {
           this.mostrarLoading(new Loading(true,"Obteniendo Registros"));
           let unidadMedida  = new UnidadMedida();
           unidadMedida.unidadMedidaId = id;
           unidadMedida.descripcion = descripcion;
           unidadMedida.estado = true;
           let response: ResponseGenerico  | undefined;
           if(this.action == 1)
                 response = await UnidadMedida.Guardar(unidadMedida);
            else 
                 response = await UnidadMedida.Editar(unidadMedida);
           if(response.isSuccess == true)
           {
               this.mostarAlert(new Alerta(response.isMessage,true,"danger",2000));
               this.modalAgregarUnidadMedida = false;
               this.modalAgregarUnidadMedidaName = "";
               await this.ObtenerUnidadMedida();
           }
           else
           {
               this.mostarAlert(new Alerta(response.isMessage,true,"danger",2000));
           }
       }
       catch(error)
       {
              //@ts-ignore
           this.mostarAlert(new Alerta(error,true,"danger",2000));
       }finally{
            this.mostrarLoading(new Loading(false,""));
    }
   }
    abrirModalAgregar()
    {   this.action = 1;
        this.modeloGenerico = undefined;
        this.titulo = "Registrar Unidad de Medida";
        this.modalAgregarUnidadMedida = true;
        this.modalAgregarUnidadMedidaName = "Formulario";
    }
    modalEditar(unidadMedida:UnidadMedida)
    {
        
       this.action = 2;
        this.titulo=  "Editar Labor";
        this.modeloGenerico = new ModeloGenerico();
        this.modeloGenerico.id = unidadMedida.unidadMedidaId;
        this.modeloGenerico.descripcion = unidadMedida.descripcion;
        this.modeloGenerico.estado = unidadMedida.estado;
       this.modalAgregarUnidadMedidaName = "Formulario";
       this.modalAgregarUnidadMedida = true;
    }
    cerrarModal()
    {
        this.action = 1;
        this.modalAgregarUnidadMedida =false;
        this.modalAgregarUnidadMedidaName = "";
        this.modeloGenerico = undefined;
    }
    editarEstado(unidadMedida:UnidadMedida)
    {
        try
        {
            this.mostrarLoading(new Loading(true,"Obteniendo Registros"));
            if(unidadMedida.countActivas> 0 && unidadMedida.estado == true)
            {
                this.unidadEdicion = unidadMedida;
                this.mensaje = `Si desactiva el Tipo de Labor ${unidadMedida.descripcion}, se procedera a desactivar 
                la cantidad de ${unidadMedida.countActivas} Labores que se encuentra asociadas`;
                this.componenteVersatil = "MensajeConfirmacion";
                return;
            }
            else
            {
                this.editarEstadoDb(unidadMedida);
            }
            
        }
        catch(error)
        {
               //@ts-ignore
            this.mostarAlert(new Alerta(error,true,"danger",2000));
        }
    }

    async editarEstadoDb(unidadMedida:UnidadMedida)
    {
        try
        {
            this.mostrarLoading(new Loading(true,"Obteniendo Registros"));
            let response = await UnidadMedida.EditarEstado(unidadMedida);
                if(response.isSuccess == true)
                {
                    this.mostarAlert(new Alerta(response.isMessage,true,"danger",2000));
                    this.ObtenerUnidadMedida();
                }
                else
                {
                    this.mostarAlert(new Alerta(response.isMessage,true,"danger",2000));
                }
        }
        catch(error)
        {
               //@ts-ignore
            this.mostarAlert(new Alerta(error,true,"danger",2000));
        }
        finally
        {
            this.mostrarLoading(new Loading(false,""));
        }
    }

    confirmarcionEditarEstado(valor:boolean)
    {
        if(valor == true)
        {
            if(this.unidadEdicion != undefined)
            this.editarEstadoDb(this.unidadEdicion);
        }
    }

    //Computed()
    get componenteDinamico()
    {
         if(this.componenteVersatil == "MensajeConfirmacion")
         {
             let objeto = {'modal' : true, 'mensaje' : this.mensaje};
             return objeto;
         }
    }
   mounted() {
        this.ObtenerUnidadMedida();   
   }
}
